import React, { FC } from 'react'

import { TextField, useRecordContext } from 'react-admin'

export const StripePlanField: FC = () => {
  const record = useRecordContext()
  if (!record) return null

  const product = record.items[0].price.product.name // TODO assumption here about there only being one subscription item. this will need to be enhanced when we include the per user pricing

  return <TextField record={{ id: null, product }} source="product" />
}
